import { IBalanceState } from '../../types/reducers/balance';

export const defaultState: IBalanceState = {
  recommendedDepositAmount: 0,
  auctionPoints: 0,
  totalBalance: 0,
  canFill: false,
};
